import React from "react";
import { GetAssetGroupsUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const AssetGroupsDropdown = ({
  resources,
  assetGroup,
  assetGroups,
  onAssetGroupChange,
  onRequestStart,
  onRequestEnd,
  containerClass,
  helperText = null,
  defaultValue = null,
  inputName = "assetgroup",
  id = "assetgroups-dropdown",
  disabled = false,
  required = false,
  addMarginBottom = false,
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["AssetGroup"]}
      value={assetGroup}
      placeholder={defaultValue ?? resources["All"]}
      values={assetGroups}
      handleChange={onAssetGroupChange}
      inputName={inputName}
      addMarginBottom={addMarginBottom}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={GetAssetGroupsUrl(true)}
      map={t => ({ key: t.id, name: t.description })}
      sort={(a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase()))}
    />
  );
};

export default AssetGroupsDropdown;
